import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface AppServiceNameEditProps {
  onSubmit: () => void;
  appServiceId: string;
  appServiceName: string;
}
export const AppServiceNameEdit = ({
  onSubmit,
  appServiceId,
  appServiceName,
}: AppServiceNameEditProps) => {
  const api = useApi();
  const [name, setName] = React.useState(appServiceName);

  const appServiceNamePost = useMutation(api.setAppServiceNameApiV1SetAppServiceNamePost, {
    onSuccess() {
      toast.success('Updated App Service name successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    appServiceNamePost.mutate({
      app_service_id: appServiceId,
      app_service_name: name,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        id="app-service-name"
        label="App Service Name"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save Name
        </Button>
      </Box>
    </Box>
  );
};
